import { cn } from "../utils/cn.js";

const SidebarShared = ({
  header,
  body,
  bodyClassName
}: {
  header: React.ReactNode;
  body: React.ReactNode;
  bodyClassName?: string;
}) => {
  return (
    <div className={`flex h-full grow flex-col `}>
      {header}
      <div
        className={cn(
          ` border-mono-200 dark:border-mono-700/50  flex  min-h-0  flex-1 flex-col pt-4 md:border-r  md:pr-4`,
          bodyClassName
        )}
      >
        <div className=" flex w-full  max-w-lg flex-1 flex-col   gap-1.5 font-medium backdrop-blur-sm min-h-0">
          {body}
        </div>
      </div>
    </div>
  );
};

export default SidebarShared;
